import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// always send cookies for cross-origin auth
axios.defaults.withCredentials = true;

// Persistent device id (used for leak-detection / device tracking)
const DEVICE_KEY = "rv_device_id";
function getDeviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36));
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}
axios.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  cfg.headers["X-Device-Id"] = getDeviceId();
  return cfg;
});

const AuthContext = createContext({ me: null, loading: true, refresh: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/me`);
      setMe(r.data?.authenticated ? r.data : null);
    } catch (err) {
      console.error("Auth refresh failed:", err);
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch (err) {
      console.error("Logout API failed (clearing local state anyway):", err);
    }
    setMe(null);
    window.location.href = "/";
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <AuthContext.Provider value={{ me, loading, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const loginWithDiscord = async () => {
  try {
    const r = await axios.get(`${API}/auth/discord/login`);
    if (r.data?.authorization_url) {
      window.location.href = r.data.authorization_url;
    }
  } catch (e) {
    alert("Could not start Discord login. Please try again.");
  }
};
